module.exports = __webpack_public_path__ + "static/media/signal-1.385dd50a.svg";